import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Card from 'antd/es/card';
import Row from 'antd/es/row';
import Col from 'antd/es/col';
import Button from 'antd/es/button';
import Form from 'antd/es/form';
import Select from 'antd/es/select';
import DatePicker from 'antd/es/date-picker';
import Input from 'antd/es/input';
// import Icon from 'antd/es/icon';

import './styles.css';

const { RangePicker } = DatePicker;

const functionIsSet = (f) => typeof f === 'function';

const MultiSearch = ({
  renderActions,
  isMobile,
  filtersShown,
  handleOnEnterPress,
  handleOnSearch,
  placeholder,
  loading,
  onStatusChange,
  onDeliverMethodChange,
  onDateFilterChange,
  noExtend,
  renderExtended,
  defaultSearchValue,
  size,
  statusList,
}) => {
  const [extendedSearch, showExtSearch] = useState(false);
  const cardSize = size || 'default';
  const statusOrder = [
    'Ny',
    'Pakkes',
    'Pakket',
    'Sendt',
    'Levert',
    'Kanselert',
    'Rest',
  ];
  const statuses = statusList || [
    { _id: 'Ny', count: 0 },
    { _id: 'Pakkes', count: 0 },
    { _id: 'Pakket', count: 0 },
    { _id: 'Sendt', count: 0 },
    { _id: 'Levert', count: 0 },
    { _id: 'Kanselert', count: 0 },
    { _id: 'Rest', count: 0 },
  ];

  return (
    <Card
      style={{
        width: '100%',
        position: 'sticky',
        top: 0,
        zIndex: 9,
      }}
      className={['filter-card', 'visible', 'card-small-2']
        .filter(
          (f) =>
            (f === 'card-small-2' && cardSize === 'small') ||
            (f !== 'card-small-2' && f !== 'visible') ||
            (f !== 'card-small-2' && !isMobile) ||
            (f !== 'card-small-2' && filtersShown)
        )
        .join(' ')}
    >
      {!extendedSearch ? (
        <Row gutter={24}>
          <Col xs={2} md={3} lg={2}>
            {functionIsSet(renderActions) && renderActions()}
          </Col>
          {functionIsSet(onStatusChange) && (
            <Col xs={11} md={11} lg={11}>
              <Select
                style={{ width: '100%' }}
                defaultValue="Ny"
                disabled={loading}
                onChange={onStatusChange}
              >
                <Select.Option value={null}>All statuses</Select.Option>
                {statuses
                  // Add order
                  .map((status) => {
                    const newStatus = { ...status };
                    newStatus.order = statusOrder.indexOf(status._id);
                    return newStatus;
                  })
                  // Sort by order
                  .sort((a, b) => a.order - b.order)
                  // Render the select options
                  .map((status, i) => (
                    <Select.Option
                      value={status._id}
                      // eslint-disable-next-line react/no-array-index-key
                      key={`status-${i}`}
                    >{`${status._id} (${status.count})`}</Select.Option>
                  ))}
              </Select>
            </Col>
          )}
          <Col xs={11} md={10} lg={11}>
            <Form>
              <Input.Search
                style={{ margin: '0' }}
                defaultValue={defaultSearchValue || ''}
                name="search-text"
                disabled={loading}
                allowClear
                id="searchValue"
                placeholder={placeholder || 'Order number, name, email'}
                onSearch={(val) => handleOnSearch(val)}
              />
            </Form>
          </Col>
          <Button
            type="link"
            onClick={() => showExtSearch(!extendedSearch)}
            style={{
              fontSize: '80%',
              textAlign: 'right',
              width: '100%',
              height: '16px',
            }}
          >
            Utvid søk
          </Button>
        </Row>
      ) : (
        <Row gutter={[24, 16]}>
          <Col xs={2} md={3} lg={2}>
            {functionIsSet(renderActions) && renderActions()}
          </Col>
          {functionIsSet(onStatusChange) && (
            <Col xs={11} md={11} lg={11}>
              <Select
                style={{ width: '100%' }}
                defaultValue="Ny"
                disabled={loading}
                onChange={onStatusChange}
              >
                <Select.Option value={null}>All statuses</Select.Option>
                {statuses
                  // Add order
                  .map((status) => {
                    const newStatus = { ...status };
                    newStatus.order = statusOrder.indexOf(status._id);
                    return newStatus;
                  })
                  // Sort by order
                  .sort((a, b) => a.order - b.order)
                  // Render the select options
                  .map((status, i) => (
                    <Select.Option
                      value={status._id}
                      // eslint-disable-next-line react/no-array-index-key
                      key={`status-${i}`}
                    >{`${status._id} (${status.count})`}</Select.Option>
                  ))}
              </Select>
            </Col>
          )}
          <Col xs={11} md={10} lg={11}>
            <Form onSubmit={handleOnEnterPress}>
              <Input.Search
                disabled={loading}
                style={{ margin: '0', width: '100%' }}
                defaultValue={defaultSearchValue || ''}
                name="search-text"
                allowClear
                id="searchValue"
                placeholder={placeholder || 'Order number, name, email'}
                onSearch={(val) => handleOnSearch(val)}
              />
            </Form>
          </Col>
          {functionIsSet(onDeliverMethodChange) && (
            <Col xs={12}>
              <Select
                style={{ width: '100%' }}
                defaultValue={null}
                disabled={loading}
                onChange={onDeliverMethodChange}
              >
                <Select.Option value={null}>All Leveringsmetode</Select.Option>
                <Select.Option value="RFID">RFID</Select.Option>
                <Select.Option value="Sporingspakke">
                  Sporingspakke
                </Select.Option>
                <Select.Option value="Kaffekruset">Kaffekruset</Select.Option>
              </Select>
            </Col>
          )}
          {functionIsSet(onDateFilterChange) && (
            <Col xs={12}>
              <RangePicker
                style={{ marginTop: '0', width: '100%' }}
                placeholder={['From', 'To']}
                disabled={loading}
                onChange={onDateFilterChange}
              />
            </Col>
          )}
          {!noExtend && functionIsSet(renderExtended) && renderExtended()}
          <Col xs={24}>
            <Button
              type="link"
              onClick={() => showExtSearch(!extendedSearch)}
              style={{
                fontSize: '80%',
                textAlign: 'right',
                width: '100%',
                height: '22px',
              }}
            >
              Utvid søk
            </Button>
          </Col>
        </Row>
      )}
    </Card>
  );
};

MultiSearch.defaultProps = {
  renderActions: () => console.log('actions'),
  isMobile: false,
  filtersShown: true,
  placeholder: '',
  loading: false,
  onStatusChange: null,
  onDeliverMethodChange: null,
  onDateFilterChange: null,
};

MultiSearch.propTypes = {
  renderActions: PropTypes.func,
  isMobile: PropTypes.bool,
  filtersShown: PropTypes.bool,
  handleOnEnterPress: PropTypes.func.isRequired,
  handleOnSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  loading: PropTypes.bool,
  onStatusChange: PropTypes.func,
  onDeliverMethodChange: PropTypes.func,
  onDateFilterChange: PropTypes.func,
};

export default MultiSearch;
